import { render } from "./CompanyDocuments.vue?vue&type=template&id=20d12aeb"
import script from "./CompanyDocuments.vue?vue&type=script&lang=js"
export * from "./CompanyDocuments.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__